import { useHistory } from "react-router-dom";
export const AthenaProducts = {
  AVIVA_FORTUNE_PLUS: { product_code: "22003", route: "/bi-fortune-plus" },
  AVIVA_POS_DHAN_SURKSHA_CODE: { product_code: "22018", route: "/bi-dhan-suraksha" },
  AVIVA_BAL_VIKAS_YOJNA_CODE: { product_code: "22028", route: "/bi-bal-vikas-yojna" },
  AVIVA_SMART_VITALS_CODE: { product_code: "22029", route: "/bi-aviva-smart-vitals" },
  AVIVA_SMART_VITALS_V02_CODE: { product_code: "22031", route: "/bi-aviva-smart-vitals-v02", name: "Aviva Smart Vitals V02" },
  AVIVA_NEW_FAMILY_INCOME_BUILDER_CODE: { product_code: "22006", route: "/bi-fib" },
  AVIVA_NEW_WEALTH_BUILDER_CODE: { product_code: "22007", route: "/bi-anwb" },
  AVIVA_SIP_SIGNATURE_INVESTMENT_PLAN_CODE: { product_code: "22008", route: "/bi-sip" },
  AVIVA_3D_TERM_PLAN_CODE: { product_code: "22019", route: "/bi-term-plan" },
  AVIVA_POS_SIGNATURE_GUARANTEED_CODE: { product_code: "22021", route: "/bi-pos-gip" },
  AVIVA_SIGNATURE_MONTHLY_INCOME_PLAN_CODE: { product_code: "22015", route: "/bi-mip" },
  AVIVA_SIGNATURE_INVESTING_PLAN_PLATINUM_CODE: { product_code: "22017", route: "/bi-sipp" },
  AVIVA_SIGNATURE_INCREASING_INCOME_PLAN_CODE: { product_code: "22020", route: "/bi-asiip" },
  AVIVA_SIGNATURE_3D_TERM_PLAN_PLATINUM_CODE: { product_code: "22023", route: "/bi-term-plan-plantinum", name: "Aviva Signature 3D Term Plan Platinum", aviva_ProductId: "16" },
  AVIVA_DIABETIC_TERM_PLAN: { product_code: "22024", route: "/bi-term-plan-diabetic", name: "Aviva Diabetic Term Plan" },
  AVIVA_SIGNATURE_3D_TERM_PLAN_PLATINUM_CODE_V2: { product_code: "22026", route: "/bi-term-plan-plantinum-v2", name: "Aviva Signature 3D Term Plan Platinum", aviva_ProductId: "18" },
  AVIVA_SMART_MONTHLY_INCOME_PLAN_CODE: { product_code: "22030", route: "/bi-smart-mip", name: "Aviva Smart Monthly Income Plan" },
};

export const AthenaProductsRouteHandler = (history, productCode) => {
  switch (productCode) {
    case AthenaProducts.AVIVA_FORTUNE_PLUS.product_code:
      return history.push(AthenaProducts.AVIVA_FORTUNE_PLUS.route);
    case AthenaProducts.AVIVA_POS_DHAN_SURKSHA_CODE.product_code:
      return history.push(AthenaProducts.AVIVA_POS_DHAN_SURKSHA_CODE.route);
    case AthenaProducts.AVIVA_BAL_VIKAS_YOJNA_CODE.product_code:
      return history.push(AthenaProducts.AVIVA_BAL_VIKAS_YOJNA_CODE.route);
    case AthenaProducts.AVIVA_SMART_VITALS_CODE.product_code:
      return history.push(AthenaProducts.AVIVA_SMART_VITALS_CODE.route);
    case AthenaProducts.AVIVA_SMART_VITALS_V02_CODE.product_code:
      return history.push(AthenaProducts.AVIVA_SMART_VITALS_V02_CODE.route);
    case AthenaProducts.AVIVA_NEW_FAMILY_INCOME_BUILDER_CODE.product_code:
      return history.push(AthenaProducts.AVIVA_NEW_FAMILY_INCOME_BUILDER_CODE.route);
    case AthenaProducts.AVIVA_NEW_WEALTH_BUILDER_CODE.product_code:
      return history.push(AthenaProducts.AVIVA_NEW_WEALTH_BUILDER_CODE.route);
    case AthenaProducts.AVIVA_SIP_SIGNATURE_INVESTMENT_PLAN_CODE.product_code:
      return history.push(AthenaProducts.AVIVA_SIP_SIGNATURE_INVESTMENT_PLAN_CODE.route);
    case AthenaProducts.AVIVA_3D_TERM_PLAN_CODE.product_code:
      return history.push(AthenaProducts.AVIVA_3D_TERM_PLAN_CODE.route);
    case AthenaProducts.AVIVA_POS_SIGNATURE_GUARANTEED_CODE.product_code:
      return history.push(AthenaProducts.AVIVA_POS_SIGNATURE_GUARANTEED_CODE.route);
    case AthenaProducts.AVIVA_SIGNATURE_MONTHLY_INCOME_PLAN_CODE.product_code:
      return history.push(AthenaProducts.AVIVA_SIGNATURE_MONTHLY_INCOME_PLAN_CODE.route);
    case AthenaProducts.AVIVA_SIGNATURE_INVESTING_PLAN_PLATINUM_CODE.product_code:
      return history.push(AthenaProducts.AVIVA_SIGNATURE_INVESTING_PLAN_PLATINUM_CODE.route);
    case AthenaProducts.AVIVA_SIGNATURE_INCREASING_INCOME_PLAN_CODE.product_code:
      return history.push(AthenaProducts.AVIVA_SIGNATURE_INCREASING_INCOME_PLAN_CODE.route);
    case AthenaProducts.AVIVA_SIGNATURE_3D_TERM_PLAN_PLATINUM_CODE.product_code:
      return history.push(AthenaProducts.AVIVA_SIGNATURE_3D_TERM_PLAN_PLATINUM_CODE.route);
    case AthenaProducts.AVIVA_DIABETIC_TERM_PLAN.product_code:
      return history.push(AthenaProducts.AVIVA_DIABETIC_TERM_PLAN.route);
    case AthenaProducts.AVIVA_SIGNATURE_3D_TERM_PLAN_PLATINUM_CODE_V2.product_code:
      return history.push(AthenaProducts.AVIVA_SIGNATURE_3D_TERM_PLAN_PLATINUM_CODE_V2.route);
    case AthenaProducts.AVIVA_SMART_MONTHLY_INCOME_PLAN_CODE.product_code:
      return history.push(AthenaProducts.AVIVA_SMART_MONTHLY_INCOME_PLAN_CODE.route);
    default:
      return history.push("/home");
  }
};

export const PaymentFrequencyConvertor = (frequency) => {
  switch (frequency) {
    case "1":
      return "Annual";
    case "2":
      return "Half Yearly";
    case "3":
      return "Quaterly";
    case "4":
      return "Monthly";
    case "5":
      return "Single Pay";
    default:
      return "-";
  }
};
